module.exports = __webpack_public_path__ + "static/media/keyActivities.bcb5e53b.svg";